import { render, staticRenderFns } from "./card-attributes.vue?vue&type=template&id=1db0e9ea"
import script from "./card-attributes.vue?vue&type=script&lang=js"
export * from "./card-attributes.vue?vue&type=script&lang=js"
import style0 from "./card-attributes.vue?vue&type=style&index=0&id=1db0e9ea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports